import {MappedValueOptionItem, ValueOptionsApiResponse} from '@common/types/documents/valueOptions.types';
import {EMPTY_VALUE_KEY} from '@common/constants/components/input/selectConstants';
import {ValueOptionsCompositionLanguagesApiResponse} from '@modules/piu/features/productSheet/components/Translations/translationsOrder.type';

export const mapValueOptionsResponse = (response: ValueOptionsApiResponse): MappedValueOptionItem[] => {
  const mappedValues =
    response?.data?.map(item => ({
      label: item.name,
      key: item.id,
      disabled: item.readOnly || false,
      ...(item.hiddenFields && {hiddenFields: item.hiddenFields})
    })) || [];

  return mappedValues?.length < 1 ? [{key: EMPTY_VALUE_KEY, label: 'EMPTY', disabled: true}] : mappedValues;
};

export const mapValueOptionsRegionCountryResponse = (response: ValueOptionsApiResponse): MappedValueOptionItem[] => {
  const mappedValues =
    response?.data?.map(item => ({
      label: item.name,
      key: item.id,
      data: item?.data?.deployedCountries.map(country => ({
        label: country.name,
        key: country.id
      })),
      disabled: item.readOnly || false,
      ...(item.hiddenFields && {hiddenFields: item.hiddenFields})
    })) || [];

  return mappedValues?.length < 1 ? [{key: EMPTY_VALUE_KEY, label: 'EMPTY', disabled: true}] : mappedValues;
};

export const mapValueOptionsCompositionLanguagesResponse = (response: ValueOptionsCompositionLanguagesApiResponse) => {
  return response.data.map(composition => {
    const {id, name, data} = composition;
    return {
      id,
      name,
      languages: data.ids.data.map(language => ({
        key: language.id,
        label: language.name
      }))
    };
  });
};
